import React from 'react'
import { Link } from 'gatsby';
const TabCustomPostBlock = ({ listSlug, customPostType, hideTabs }) => {
    const numberHideTabs = hideTabs && hideTabs.length === 4 ? true : false
    return (
        !numberHideTabs && (
            <div className="tab-wrapper">
                <div className="tab-item">
                    <Link className="button" to={`${listSlug.overviewSlug}/`} activeClassName="active">OVERVIEW</Link>
                </div>
                {
                    (!hideTabs || !hideTabs.includes('Data Layer Samples')) && (
                        <div className="tab-item">
                            <Link className="button" to={`${listSlug.datalayersamplesSlug}/`} activeClassName="active">DATA LAYER SAMPLES</Link>
                        </div>
                    )
                }
                {
                    customPostType === 'listener' ? (
                        (!hideTabs || !hideTabs.includes('Tracking Integrations')) && (
                            <div className="tab-item">
                                <Link className="button" to={`${listSlug.trackingintegrationsSlug}/`} partiallyActive={true} activeClassName="active">INTEGRATIONS</Link>
                            </div>
                        )
                    ) : (
                            (!hideTabs || !hideTabs.includes('Listeners')) && (
                                <div className="tab-item">
                                    <Link className="button" to={`${listSlug.listenersSlug}/`} partiallyActive={true} activeClassName="active">LISTENERS</Link>
                                </div>
                            )
                        )
                }
                {
                    (!hideTabs || !hideTabs.includes('Use Cases')) && (
                        <div className="tab-item">
                            <Link className="button" to={`${listSlug.usecasesSlug}/`} activeClassName="active">USE CASES</Link>
                        </div>
                    )
                }
                {
                    (!hideTabs || !hideTabs.includes('Help')) && (
                        <div className="tab-item">
                            <Link className="button" to={`${listSlug.helpSlug}/`} activeClassName="active">HELP</Link>
                        </div>
                    )
                }
            </div>
        )

    )
}

export default TabCustomPostBlock
